import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import { getUtilitySetupSignupFormFields } from 'client/components/SrUtilitySetup/SrUtilitySetupSignup';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';

import './SrUtilityProfitRenterContactInformationModal.less';

const getFormFields = () => {
  return getUtilitySetupSignupFormFields({
    isRenterContactInformationForm: true,
  });
};

const SrUtilityProfitRenterContactInformationModal = ({
  address,
  onClose,
  onSubmit,
  initialValues,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <SrDarkModal style={{ padding: '30px' }}>
      <SrModalContent width="412px" innerStyle={{ padding: 0, maxWidth: '412px' }}>
        <Formik
          onSubmit={(formValues) => {
            setIsSubmitting(true);
            onSubmit(formValues, () => setIsSubmitting(false));
          }}
          initialValues={createInitialValues({
            formFields: getFormFields(),
            defaultValues: initialValues || {},
          })}
          validate={(formValues) => {
            const formFields = getFormFields();
            return createFormValidationFn(formFields)(formValues);
          }}
          render={(formikBag) => {
            const formFields = getFormFields();

            return (
              <Form>
                <div styleName="header">
                  <div styleName="headerBox">
                    <span styleName="headerTitle">Send renter reminders</span>
                    <span styleName="headerSubtitle">{address?.display}</span>
                    <span styleName="headerText">
                      They will receive reminder texts and emails until they confirm all utilities.
                    </span>
                  </div>
                </div>
                <div styleName="divider" />
                <div styleName="body">
                  <div>
                    {formFields.map((field) => (
                      <SrFormikField
                        key={field.id}
                        formField={field}
                        formikBag={formikBag}
                        theme={SR_FIELD_THEME_ADOBE}
                        className="utilityProviderQuestion"
                      />
                    ))}
                  </div>
                  <div styleName="footer">
                    <SrButton
                      type="submit"
                      theme={SR_BUTTON_THEME_ADOBE_GREEN}
                      disabled={isSubmitting}
                    >
                      Start Sending
                    </SrButton>
                    <SrButton
                      type="button"
                      theme={SR_BUTTON_THEME_ADOBE_GREY}
                      margin="12px 0px"
                      onClick={onClose}
                      disabled={isSubmitting}
                    >
                      Cancel
                    </SrButton>
                  </div>
                </div>
              </Form>
            );
          }}
        />
      </SrModalContent>
    </SrDarkModal>
  );
};

SrUtilityProfitRenterContactInformationModal.propTypes = {
  address: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

SrUtilityProfitRenterContactInformationModal.displayName =
  'SrUtilityProfitRenterContactInformationModal';

export default SrUtilityProfitRenterContactInformationModal;
